/** sync: the sync tray — following a publish until every player plays it. Arabic is a draft for native review. */
const en = {
  "chipFailing": "Can't download",
  "clickForIssue": "Click to see the issue",
  "noIssueYet": "No Health Check issue for this player yet: it is raised once the problem lasts a few minutes.",
  "nFailing": "{n} can't download | {n} can't download",
  "nNeedAttention": "{n} needs attention | {n} need attention",
  "st_failing": "Can't download: {why}",
  "err_unreachable": "it can't reach the server",
  "err_not_allowed": "the server refused it (signed out or not allowed)",
  "err_wrong_address": "the content's address doesn't match its server (check the server address setting)",
  "err_not_found": "the content wasn't found on the server",
  "err_rejected": "the content failed the player's checks",
  "err_storage_full": "its storage is full",
  "err_other": "the update keeps failing",
  "tray": "Updating players",
  "expand": "Expand",
  "collapse": "Collapse",
  "dismiss": "Stop following",
  "view": "View",
  "labelTarget": "New content → {name}",
  "labelMany": "{n} items",
  "labelChange": "Content changed → {name}",
  "labelPaired": "New device for {name}",
  "allDone": "Up to date | All {n} players up to date",
  "readyOf": "{ready} of {total} players up to date",
  "offlineOne": "{name} is offline: it will get the new content when it's back online.",
  "offlineMany": "The player is offline: it will get the new content when it's back online. | All {n} players are offline: they'll get the new content when they're back online.",
  "offlineChangedOne": "{name} is offline: it will update when it's back online.",
  "offlineChangedIt": "It's offline: it will update when it's back online.",
  "offlineIt": "It's offline: it will get the new content when it's back online.",
  "offlineChangedMany": "The player is offline: it will update when it's back online. | All {n} players are offline: they'll update when they're back online.",
  "viewPlayer": "View player",
  "inclSynced": "Includes {n} player that plays in sync with {lead} | Includes {n} players that play in sync with {lead}",
  "inclSyncedMany": "Includes {n} player that plays in sync with a lead you published to | Includes {n} players that play in sync with leads you published to",
  "syncedWhy": "Synchronized Playback: a group's players play their lead's content, so publishing to the lead updates them too.",
  "playsInSync": "Plays in sync with {lead} (Synchronized Playback), so it gets this content too",
  "nOfflineSynced": "{n} synced player behind (offline) | {n} synced players behind (offline)",
  "nDownloading": "{n} updating",
  "nSyncing": "{n} updating",
  "nWaiting": "{n} waiting",
  "nOffline": "{n} behind (offline)",
  "parked": "Behind (offline): the player updates when it's back | Behind (offline): the {n} players update when they're back",
  "nProblem": "{n} problem | {n} problems",
  "st_done": "Up to date",
  "st_partial": "{n} file missing: {why} | {n} files missing: {why}",
  "st_downloading": "Updating",
  "st_syncing": "Updating",
  "st_downloadingPct": "Updating {pct} %",
  "st_waiting": "Waiting: sent, the player hasn't picked it up yet",
  "st_offline": "Behind (offline): updates when it's back",
  "st_offlineSince": "Behind (offline) since {ago}: updates when it's back",
  "st_problem": "Out of date: {n} file couldn't download ({why}) | Out of date: {n} files couldn't download ({why})",
  "whyUnknown": "download failed",
  "fix": "Open Live Control",
  "checkPlayer": "Check player",
  "chipUpToDate": "Up to date",
  "chipUpdating": "Updating",
  "chipMissingFiles": "{n} file missing | {n} files missing",
  "chipStuck": "Out of date",
  "chipBehindOffline": "Behind (offline)",
  "chipWaiting": "Waiting",
  "outOfSync": "Out of sync",
  "colContent": "Content",
  "groupSummary": "{ready} of {total} players up to date",
  "groupBehind": "{n} out of sync | {n} out of sync",
  "hint": "A player counts as ready once it is playing the new content. Players that are offline get it when they reconnect; files that fail are retried by themselves and listed in Health Check."
};
const ar: typeof en = {
  "chipFailing": "تعذّر التنزيل",
  "clickForIssue": "انقر لعرض المشكلة",
  "noIssueYet": "لا توجد مشكلة في فحص السلامة لهذا المشغّل بعد: تُسجَّل عندما تستمر المشكلة بضع دقائق.",
  "nFailing": "لا مشغلات | مشغّل واحد تعذّر التنزيل عليه | مشغّلان تعذّر التنزيل عليهما | {n} مشغلات تعذّر التنزيل عليها | {n} مشغلًا تعذّر التنزيل عليه | {n} مشغل تعذّر التنزيل عليه",
  "nNeedAttention": "لا شيء | مشغّل واحد يحتاج إلى انتباه | مشغّلان يحتاجان إلى انتباه | {n} مشغلات تحتاج إلى انتباه | {n} مشغلًا يحتاج إلى انتباه | {n} مشغل يحتاج إلى انتباه",
  "st_failing": "تعذّر التنزيل: {why}",
  "err_unreachable": "لا يستطيع الوصول إلى الخادم",
  "err_not_allowed": "رفضه الخادم (تم تسجيل خروجه أو غير مسموح)",
  "err_wrong_address": "عنوان المحتوى لا يطابق خادمه (تحقق من إعداد عنوان الخادم)",
  "err_not_found": "لم يُعثر على المحتوى في الخادم",
  "err_rejected": "لم يجتز المحتوى فحوصات المشغّل",
  "err_storage_full": "مساحة التخزين ممتلئة",
  "err_other": "يستمر فشل التحديث",
  "tray": "تحديث المشغّلات",
  "expand": "توسيع",
  "collapse": "طي",
  "dismiss": "إيقاف المتابعة",
  "view": "عرض",
  "labelTarget": "محتوى جديد ← {name}",
  "labelMany": "{n} عناصر",
  "labelChange": "تغيّر المحتوى ← {name}",
  "labelPaired": "جهاز جديد لـ {name}",
  "allDone": "محدّث | جميع المشغّلات ({n}) محدّثة",
  "readyOf": "{ready} من {total} مشغّلات محدّثة",
  "offlineOne": "{name} غير متصل: سيصله المحتوى الجديد عند عودته للاتصال.",
  "offlineMany": "المشغّل غير متصل: سيصله المحتوى الجديد عند عودته. | جميع المشغلات ({n}) غير متصلة: سيصلها المحتوى الجديد عند عودتها.",
  "offlineChangedOne": "{name} غير متصل: سيتحدّث عند عودته للاتصال.",
  "offlineChangedIt": "إنه غير متصل: سيتحدّث عند عودته للاتصال.",
  "offlineIt": "إنه غير متصل: سيصله المحتوى الجديد عند عودته للاتصال.",
  "offlineChangedMany": "المشغّل غير متصل: سيتحدّث عند عودته. | جميع المشغلات ({n}) غير متصلة: ستتحدّث عند عودتها.",
  "viewPlayer": "عرض المشغّل",
  "inclSynced": "يشمل مشغّلًا واحدًا يعمل بالتزامن مع {lead} | يشمل {n} مشغلات تعمل بالتزامن مع {lead}",
  "inclSyncedMany": "يشمل مشغّلًا واحدًا يعمل بالتزامن مع مشغّل رئيسي نشرت إليه | يشمل {n} مشغلات تعمل بالتزامن مع مشغلات رئيسية نشرت إليها",
  "syncedWhy": "التشغيل المتزامن: مشغلات المجموعة تعرض محتوى المشغّل الرئيسي، لذا النشر إليه يحدّثها أيضًا.",
  "playsInSync": "يعمل بالتزامن مع {lead} (التشغيل المتزامن)، لذا يصله هذا المحتوى أيضًا",
  "nOfflineSynced": "مشغّل متزامن واحد متأخر (غير متصل) | {n} مشغلات متزامنة متأخرة (غير متصلة)",
  "nDownloading": "{n} يتم التحديث",
  "nSyncing": "{n} يتم التحديث",
  "nWaiting": "{n} بانتظار",
  "nOffline": "{n} متأخر (غير متصل)",
  "parked": "متأخر (غير متصل): يتحدّث المشغّل عند عودته | متأخر (غير متصل): تتحدّث المشغّلات ({n}) عند عودتها",
  "nProblem": "مشكلة واحدة | {n} مشكلات",
  "st_done": "محدّث",
  "st_partial": "ملف واحد ناقص: {why} | {n} ملفات ناقصة: {why}",
  "st_downloading": "يتم التحديث",
  "st_syncing": "يتم التحديث",
  "st_downloadingPct": "يتم التحديث {pct} %",
  "st_waiting": "بانتظار: أُرسل ولم يستلمه المشغّل بعد",
  "st_offline": "متأخر (غير متصل): يتحدّث عند عودته",
  "st_offlineSince": "متأخر (غير متصل) منذ {ago}: يتحدّث عند عودته",
  "st_problem": "غير محدّث: تعذّر تنزيل ملف واحد ({why}) | غير محدّث: تعذّر تنزيل {n} ملفات ({why})",
  "whyUnknown": "فشل التنزيل",
  "fix": "فتح التحكم المباشر",
  "checkPlayer": "تحقق من المشغّل",
  "chipUpToDate": "محدّث",
  "chipUpdating": "يتم التحديث",
  "chipMissingFiles": "ملف واحد ناقص | {n} ملفات ناقصة",
  "chipStuck": "غير محدّث",
  "chipBehindOffline": "متأخر (غير متصل)",
  "chipWaiting": "بانتظار",
  "outOfSync": "غير متزامن",
  "colContent": "المحتوى",
  "groupSummary": "{ready} من {total} مشغّلات محدّثة",
  "groupBehind": "{n} غير متزامن | {n} غير متزامنة",
  "hint": "يُعد المشغّل جاهزًا عندما يعرض المحتوى الجديد. المشغّلات غير المتصلة تستلمه عند إعادة الاتصال، والملفات المتعذّرة يُعاد تنزيلها تلقائيًا وتظهر في فحص الحالة."
};
export default { en, ar };
